<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between align-center" cols="12">
                <div>
                    <h1 class="text-left text-h5 font-weight-bold">Plans &amp; Upgrade</h1>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <plan-picker @changed="onChanged"/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import PlanPicker from "@/components/globals/PlanPicker.vue";

// The owner-only redirect that used to live here now runs in the router's
// beforeEach, driven by meta.ownerOnly, so /invoices and /payment-methods get
// the same treatment instead of only this page having a bespoke one.

// PlanPicker reloads its own state after a change; nothing else on this page
// depends on it, so this is just a hook point.
const onChanged = () => {};
</script>
